import React from 'react';

import { IconButton, SvgIcon } from '@infoods/lifebase-ui';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import classNames from 'classnames';

import classes from './EditDeleteButtonGroup.module.scss';
import { GridTableCell } from '../GridTableCell/GridTableCell';
import { SeparatorLine } from '../../ui-components';
import { openConfirmationModal } from '../../../features/confirmation';
import { ReactComponent as editOptionIcon } from '../../../../../../assets/images/material-icons/edit-option.svg';

type EditDeleteButtonGroupProps = {
  onEdit: () => void;
  onDelete: () => void;
  modalTitle: string;
  confirmBtnText?: string;
  size?: 'large' | 'medium';
};

const EditDeleteButtonGroup = ({
  onEdit,
  onDelete,
  modalTitle,
  confirmBtnText,
  size = 'large',
}: EditDeleteButtonGroupProps) => {
  const containerClassName = classNames(classes.iconsContainer, classes[size]);

  const handleDelete = () => {
    openConfirmationModal({
      title: modalTitle,
      confirmBtnConfig: { onClick: onDelete, text: confirmBtnText },
    });
  };

  return (
    <GridTableCell justify="end" className={containerClassName}>
      <SeparatorLine />
      <IconButton onClick={onEdit} color="secondary" data-test-id="edit-btn">
        <SvgIcon component={editOptionIcon} fontSize="small" inheritViewBox />
      </IconButton>
      <IconButton onClick={handleDelete} color="secondary" data-test-id="delete-btn">
        <DeleteOutlineRoundedIcon fontSize={size} />
      </IconButton>
    </GridTableCell>
  );
};

export { EditDeleteButtonGroup };
